import { WprModel } from '../../wpr-framework/view/deco/WprModel';
import { WprDI_ScopeModel } from '../../wpr-framework/view/di/WprDI_ScopeModel';
import { BaseWindowViewScope } from '../base/BaseWindowViewScope';
import { FirstScopeInfo } from '../../scope/FirstScopeInfo';
import { AuthMailInfo } from '../../service/models/auth-mail/auth-mail-info';
import { WprDI_GlobalScopeModel } from '../../wpr-framework/view/di/WprDI_GlobalScopeModel';
import { SystemService } from '../../service/SystemService';
import { HttpUtils } from '../../common/http/HttpUtils';

/**
 * メール送信完了ビュー情報
 */
export class CompleteMailComponentView extends BaseWindowViewScope<FirstScopeInfo> {
	// モデル  ------------------------------------------------------------------
	@WprDI_GlobalScopeModel('product')
	private m_ProductCode:	string 			= null;
	@WprDI_ScopeModel('AuthMailInfo')
	@WprModel('AuthMailInfo')
    private m_AuthMailInfo: AuthMailInfo	= null;
	// -------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('step4_mail-finish');
	}
	// --------------------------------------------------------------------------
		
	// override メソッド  --------------------------------------------------------
	/**
	 * コントロール定義設定
	 */
	public onRegisterConfig(): void {
		this.addConfig('mailAddress', 'アドレス', 'AuthMailInfo');
	}

	/**
	 * ビュー表示通知
	 */
	public onShowView(): void {
		super.onShowView();
		HttpUtils.finish('/finish');
		this.onUtagView();
		this.refreshView();
	}

	/**
	 * 商品コード取得
	 */
	public get productCode(): string { 
		return this.m_ProductCode; 
	}
	// --------------------------------------------------------------------------
}
